import { ChannelsForChannelListFragment } from '@designage/gql';

export interface IChannelState {
  loading?: boolean;
  channel?: ChannelsForChannelListFragment;
}

export const initialChannelState: IChannelState = {};
